module.exports = __webpack_public_path__ + "img/two_lights_2.afec240b.png";